import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CityPort } from '../../../domain/commerce-registry/ports/city.port';
import type { CityOption } from '../../../domain/commerce-registry/models/commerce-landing.model';
import type { CityApiResponse } from '../../../domain/commerce-registry/models/city-api.model';
import { ENVIRONMENT } from '../../../../environments/environment';

@Injectable()
export class CityApiAdapter extends CityPort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  loadByCountry(codPais: string): Observable<CityOption[]> {
    const base = ENVIRONMENT.apiMobileUrl?.trim();
    if (!base) return of([]);

    const url = `${base.replace(/\/$/, '')}/api/ciudades?codPais=${encodeURIComponent(codPais)}`;

    return this.http.get<CityApiResponse>(url).pipe(
      map((res) =>
        (res?.data ?? [])
          .filter((c) => c.nombre?.trim())
          .map((c) => ({
            code: String(c.id),
            label: c.nombre.trim(),
          })),
      ),
      catchError(() => of([])),
    );
  }
}
